// extracted by mini-css-extract-plugin
export default {"box_right":"DisplayBoxRight_box_right__cKz3+"};